import store from "../store";

export default {
  computed: {
    is_admin() {
      return this.user.roles[0].name === "admin";
    },
    is_customer() {
      return this.user.roles[0].name === "Integrador";
    },
    can_view_budgets() {
      return this.permissions.includes("view all budgets") || this.permissions.includes("view budgets");
    },
    can_view_orders() {
      return this.permissions.includes("view all orders") || this.permissions.includes("view orders");
    },
    can_add_product_supplier_in_kit() {
      return this.permissions.includes("kit add product supplier");
    },
    can_edit_kit_without_restriction() {
      return this.permissions.includes("edit kit without restriction");
    },
    can_view_kit_prices() {
      return this.permissions.includes("view kit prices");
    },
    can_view_kit_margin() {
      return this.permissions.includes("view kit margin");
    },
    can_give_discount() {
      return this.permissions.includes("give discount");
    },
    can_dimension_shipping_ciffob() {
      return this.permissions.includes("dimension shipping ciffob");
    },
    can_view_menu_dashboard() {
      return this.permissions.includes("view menu dashboard");
    },
    can_view_menu_dimensionar() {
      return this.permissions.includes("view menu dimensionar");
    },
    can_view_menu_orcamentos() {
      return this.permissions.includes("view menu orcamentos");
    },
    can_view_menu_pedidos() {
      return this.permissions.includes("view menu pedidos");
    },
    can_view_menu_stringsizer() {
      return this.permissions.includes("view menu stringsizer");
    },
    can_view_menu_produtos() {
      return this.permissions.includes("view menu produtos");
    },
    can_view_menu_categorias() {
      return this.permissions.includes("view menu categorias");
    },
    can_view_menu_marcas() {
      return this.permissions.includes("view menu marcas");
    },
    can_view_menu_usuarios() {
      return this.permissions.includes("view menu usuarios");
    },
    can_view_menu_clientes() {
      return this.permissions.includes("view menu clientes");
    },
    can_view_menu_cargos() {
      return this.permissions.includes("view menu cargos");
    },
    can_view_menu_permissoes() {
      return this.permissions.includes("view menu permissoes");
    },
    can_view_menu_frete() {
      return this.permissions.includes("view menu frete");
    },
    can_view_menu_fornecedores() {
      return this.permissions.includes("view menu fornecedores");
    },
    can_view_menu_banner() {
      return this.permissions.includes("view menu banner");
    },
    can_give_all_discount_in_orders() {
      return this.permissions.includes("give all discount in orders");
    },
    can_view_percent_sales_promotion() {
      return this.permissions.includes("view percent sales promotion");
    },
    can_view_shipping_price() {
      return this.permissions.includes("view kit shipping price");
    },
    can_view_menu_cadastrar_cliente() {
      return this.permissions.includes("view menu cadastrar cliente");
    },
    can_edit_order_sales_promotion() {
      return this.permissions.includes("edit order sales promotion");
    },
    can_view_metrics() {
      return this.permissions.includes("view metrics");
    }
  },
  data() {
    return {
      permissions: store.getters["permissions"],
      user: store.getters["user"]
    }
  },
}
